<template>
  <section class="defaultSectionMargins container--Small">
    <div ref="cookieScript"></div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });

  const cookieScript = ref(null);

  onMounted(() => {
    if (cookieScript.value) {
      const script = document.createElement('script');
      script.src = '/resources/js/cookiebot.js';
      script.async = true;

      // id CookieDeclaration is specified in the cookiebot.js file and is necessary for the script to work
      cookieScript.value.id = 'CookieDeclaration';
      
      cookieScript.value.appendChild(script);
    }
  });
</script>